/* Item.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./Item.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { PureComponent } from 'react';
var placeholderStyles = null;
var placeholderTaskStyles = null;
var decisionStyles = null;
var contentStyles = null;
var taskStyles = null;
var Item = /*#__PURE__*/function (_PureComponent) {
  function Item() {
    _classCallCheck(this, Item);
    return _callSuper(this, Item, arguments);
  }
  _inherits(Item, _PureComponent);
  return _createClass(Item, [{
    key: "renderPlaceholder",
    value: function renderPlaceholder() {
      var _this$props = this.props,
        children = _this$props.children,
        placeholder = _this$props.placeholder,
        showPlaceholder = _this$props.showPlaceholder,
        itemType = _this$props.itemType;
      if (!showPlaceholder || !placeholder || children) {
        return null;
      }
      return /*#__PURE__*/React.createElement("span", {
        "data-testid": "task-decision-item-placeholder",
        "data-component": "placeholder",
        contentEditable: false,
        className: ax(["_18s81hzh _1reo15vq _18m915vq _kqswstnw _syaz131l _lcxvglyw _1bto1l2s _o5721q9c _p12f1dza", itemType === 'TASK' && "_18s815t0"]),
        style: {
          "--_tptct2": ix("0 0 0 calc(".concat("var(--ds-space-100, 8px)", " * 3.5)")),
          "--_1yfnyhr": ix("0 0 0 calc(".concat("var(--ds-space-100, 8px)", " * 3)"))
        }
      }, placeholder);
    }
  }, {
    key: "renderMessageAppearance",
    value: function renderMessageAppearance() {
      var _this$props2 = this.props,
        contentRef = _this$props2.contentRef,
        children = _this$props2.children,
        icon = _this$props2.icon,
        itemType = _this$props2.itemType,
        checkBoxId = _this$props2.checkBoxId,
        dataAttributes = _this$props2.dataAttributes;
      if (itemType === 'TASK') {
        return /*#__PURE__*/React.createElement("div", {
          id: "".concat(checkBoxId, "-wrapper"),
          className: ax(["_1e0c1txw _2lx2vrvc _kqswh2mm"])
        }, icon, this.renderPlaceholder(), /*#__PURE__*/React.createElement("div", _extends({
          "data-component": "content",
          ref: contentRef
        }, dataAttributes, {
          className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1wug _slp31hna _1ul9idpf"])
        }), children));
      } else if (itemType === 'DECISION') {
        return /*#__PURE__*/React.createElement("div", {
          "data-testid": "elements-decision-item",
          "data-decision-wrapper": "true",
          className: ax(["_2rkosqtm _1e0c1txw _2lx2vrvc _19pku2gc _2hwxidpf _otyridpf _18u0idpf _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvutpp _bfhkm7j4 _kqswh2mm _14hd1wug"])
        }, icon, this.renderPlaceholder(), /*#__PURE__*/React.createElement("div", _extends({
          "data-component": "content",
          ref: contentRef
        }, dataAttributes, {
          className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1wug _slp31hna _1ul9idpf"])
        }), children));
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderMessageAppearance();
    }
  }]);
}(PureComponent);
_defineProperty(Item, "defaultProps", {
  appearance: 'inline'
});
export { Item as default };